import { IconClockAlert } from '@justeattakeaway/pie-icons-react';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React, { FC } from 'react';
import { globalStyles } from 'snacks-design-system';
import style from './TagDelayed.module.scss';
import { useTranslation } from 'react-i18next';
import PIEText from '@src/shared/components/PIEText';

const { xdsSpacingB } = globalStyles;
interface ITagDelayedProps {
  delayedTime?: string;
}
const TagDelayed: FC<ITagDelayedProps> = ({ delayedTime }) => {
  const { t } = useTranslation();
  return (
    <PIETag mode={ETagsColorType.Error}>
      <PIEComponentUtil paddingX={xdsSpacingB}>
        <PIEText
          size="var(--xds-font-size-14)"
          text={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <IconClockAlert className={style.icon} size="xs" style={{ marginRight: '4px' }} />
              {t('order.status_DELAYED')} {delayedTime ? delayedTime : ''}
            </div>
          }
          truncate={true}
        ></PIEText>
      </PIEComponentUtil>
    </PIETag>
  );
};

export default TagDelayed;
